import { handleResponse, restartUserSession, authHeader } from '../helpers'

export const shippingAddressService = {
    createCustomer,
    updateCustomerAddress,
    applyCustomerPromocode,
}

function createCustomer ({blogGuid, customer}) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(customer)
    }

    return fetch(`/shipping-address/${blogGuid}/create-customer`, requestOptions).then(handleResponse)
}

function updateCustomerAddress ({blogGuid, customer}) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(customer)
    }

    return fetch(`/shipping-address/${blogGuid}/update-customer-address`, requestOptions).then(handleResponse)
}

function applyCustomerPromocode ({blogGuid, customer}) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(customer)
    }

    return fetch(`/shipping-address/${blogGuid}/apply-customer-promocode`, requestOptions).then(handleResponse)
}
